(function () {
  function syncGroup(fieldset) {
    fieldset.classList.remove('variant-cards--stacked');

    var rows = fieldset.querySelectorAll('label.variant-card .variant-card__row');
    var wrapped = false;

    for (var i = 0; i < rows.length; i++) {
      var name = rows[i].querySelector('.variant-card__name');
      var price = rows[i].querySelector('.variant-card__price');
      if (!name || !price) continue;
      if (price.offsetTop > name.offsetTop) {
        wrapped = true;
        break;
      }
    }

    if (wrapped) fieldset.classList.add('variant-cards--stacked');
  }

  function syncAll() {
    var fieldsets = document.querySelectorAll('.product-form__input.variant-cards');
    for (var i = 0; i < fieldsets.length; i++) syncGroup(fieldsets[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  window.addEventListener('load', syncAll);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 100);
  });
})();
